import React, {useState, useEffect} from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBTypography } from 'mdb-react-ui-kit';
import '../styles/index.css';
import grid1 from "../images/grid1.jpg"
import grid2 from "../images/grid2.jpg"
import grid3 from "../images/grid3.jpg"
import { useLanguage } from '../context/LanguageContext';

export default function Services() {
    const { language } = useLanguage();

    return (
        <MDBContainer breakpoint='lg' id='service-container'>
            <MDBTypography style={{fontWeight: "600"}} tag='div' className='display-6 pb-3 mb-3 border-bottom' data-aos="fade-up">
                {language === 'EN' ? 'Solutions and Services' : 'Soluții & Servicii'}
            </MDBTypography>
            <MDBRow className='g-2' data-aos="fade-up" data-aos-duration='700' data-aos-delay="200">
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Ventilation' : 'Ventilație'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN' 
                                ? 'Custom designed ventilation systems with optional heat recovery, humidification, filtration, or geo-ventilation, designed to meet residential and industrial standards.'
                                : 'Sisteme de ventilație proiectate personalizat, cu opțiuni de recuperare de căldură, umidificare, filtrare sau geo-ventilație, conforme cu standardele rezidențiale și industriale.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Air conditioning' : 'Aer condiționat'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN'
                                ? 'Quiet, energy-efficient air conditioning systems, standalone or integrated with ventilation, providing precise zone control for cooling and heating.'
                                : 'Sisteme de aer condiționat silențioase și eficiente energetic, independente sau integrate cu ventilația, oferind control precis pe zone pentru răcire și încălzire.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Heating Systems' : 'Sisteme de Încălzire'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN'
                                ? 'Efficient low-temperature heating solutions using boilers, heat pumps, or hybrid systems, tailored to each space for optimal comfort and energy performance.'
                                : 'Soluții eficiente de încălzire de temperatură joasă, utilizând centrale termice, pompe de căldură sau sisteme hibride, adaptate fiecărui spațiu pentru confort optim și performanță energetică ridicată.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Hot water' : 'Apă caldă'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN'
                                ? 'Hot water for the whole family, available when you need it, produced efficiently from conventional and renewable sources.'
                                : 'Apă caldă pentru întreaga familie, disponibilă exact atunci când aveți nevoie, produsă eficient din surse convenționale și regenerabile.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Solar panels' : 'Panouri solare'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN'
                                ? 'Solar thermal solutions for hot water and heating support, reducing energy consumption and environmental impact, especially in transitional seasons.'
                                : 'Soluții solare termice pentru producerea apei calde și suport la încălzire, reducând consumul de energie și impactul asupra mediului, în special în sezoanele de tranziție.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='p-3 col-service'>
                        <MDBTypography variant='h3' tag='div' className='p-3 mb-3 service-name'>
                            {language === 'EN' ? 'Consulting' : 'Consultanță'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead mb-0'>
                            {language === 'EN'
                                ? 'Expert HVAC consulting for residential and industrial projects, on-site or remote, delivering tailored solutions to maximize comfort and energy efficiency.'
                                : 'Consultanță HVAC de specialitate pentru proiecte rezidențiale și industriale, la fața locului sau de la distanță, oferind soluții personalizate pentru maximizarea confortului și eficienței energetice.'}
                        </MDBTypography>
                    </div>
                </MDBCol>
            </MDBRow>

            <MDBRow className='g-3 mt-5' data-aos="fade-up" data-aos-duration='700' data-aos-delay="300">
                {/* First Image */}
                <MDBCol md='4'>
                    <img 
                        src={grid1} 
                        className='img-fluid rounded shadow-sm' 
                        alt='HVAC Installation 1' 
                        style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                    />
                </MDBCol>

                {/* Second Image */}
                <MDBCol md='4'>
                    <img 
                        src={grid2} 
                        className='img-fluid rounded shadow-sm' 
                        alt='HVAC Installation 2' 
                        style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                    />
                </MDBCol>

                {/* Third Image */}
                <MDBCol md='4'>
                    <img 
                        src={grid3} 
                        className='img-fluid rounded shadow-sm' 
                        alt='HVAC Installation 3' 
                        style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                    />
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}